import { ValidatorFn, AbstractControl } from "@angular/forms";

export const personalNumberValidator: ValidatorFn = (control: AbstractControl): { [key: string]: any | null } => {

  if (!control) {
    return null;
  }

  let input: string = control.value;

  // Check valid length & form
  if (!input) {
    return { isEmpty: true };
  }

  if (input.indexOf('-') === -1) {
    if (input.length === 10) {
      input = input.slice(0, 6) + '-' + input.slice(6);
    } else {
      input = input.slice(0, 8) + '-' + input.slice(8);
    }
  }

  if (!input.match(/^(\d{2})?(\d{2})(\d{2})(\d{2})\-(\d{4})$/)) {
    return { invalidFormat: true };
  }

  const isValidDate = (year: number, month: number, day: number): boolean => {
    month--; // i javascript är januari = 0 och december = 11 ... xD
    day %= 60; // tillåt samordningsnummer

    const currentDate: Date = new Date();

    if (year < 100) {
      const currentYear = currentDate.getFullYear();
      while (year < currentYear - 100) { // t.ex. <= 1920 för år 2020
        year += 100;
      }
    }

    const birthday: Date = new Date(year, month, day);

    return (
      Object.prototype.toString.call(birthday) === '[object Date]' &&
      !isNaN(birthday.getTime()) &&
      birthday.getFullYear() === year &&
      birthday.getMonth() === month &&
      birthday.getDate() === day &&
      birthday <= currentDate);
  };

  const year: number = Number((RegExp.$1 || '') + RegExp.$2);
  const month: number = Number(RegExp.$3);
  const day: number = Number(RegExp.$4);

  // Check valid date
  if (!isValidDate(year, month, day)) {
    return { invalidBirthday: true };
  }

  // Clean input
  input = input.replace('-', '');
  if (input.length === 12) {
    input = input.substring(2);
  }

  const parity: number = input.length % 2;
  let sum: number = 0;
  let digit: number;

  // Check luhn algorithm
  for (let i = 0; i < input.length; i++) {
    digit = parseInt(input.charAt(i), 10);
    if (i % 2 === parity) digit *= 2;
    if (digit > 9) digit -= 9;
    sum += digit;
  }

  if (sum % 10) {
    return { invalidCheckDigit: true };
  }

  return null;
}

export interface personalNumberErrors {
  invalidBirthday?: boolean;
  invalidCheckDigit?: boolean;
  invalidFormat?: boolean;
  invalidLength?: boolean;
  isEmpty?: boolean;
}
